// Ring 0 — seeded RNG. NO Phaser imports. NO `Math` `.` `random` calls anywhere
// in this file (or anywhere under src/, enforced by `npm run lint:rng`).
// CLAUDE.md anti-pattern.
//
// mulberry32 (Tommy Ettinger, public domain) — 32-bit deterministic PRNG.
// Identical output across browsers; survives JIT differences that have
// historically broken built-in PRNG reproducibility.
//
// Usage:
//   Rng.set(42);           // re-seed
//   Rng.next();            // float in [0, 1)
//   Rng.int(52);           // int in [0, 52) — EXCLUSIVE upper bound
//
// IMPORTANT: `Rng.int(maxExclusive)` returns values in `[0, maxExclusive)`.
// This is the standard contract for Fisher-Yates `[0, i+1)` sampling.
// Do NOT call as `Rng.int(min, max)` — that signature does not exist.

let _seed = 1;
let _state = 1;

export const Rng = {
  set(seed: number): void {
    _seed = seed >>> 0;
    _state = _seed;
  },

  get seed(): number {
    return _seed;
  },

  // mulberry32 — public domain
  next(): number {
    let t = (_state = (_state + 0x6D2B79F5) >>> 0);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296; // [0, 1)
  },

  // EXCLUSIVE upper bound: returns int in [0, maxExclusive).
  int(maxExclusive: number): number {
    return Math.floor(Rng.next() * maxExclusive);
  },
};
